import Navbar from "../components/navbar"
import Footer from "../components/footer"
import front_model from '../images/front-model.jpg'
import LoadingOverlay from "../components/loading"
import emptyList from "../components/empty_list"
import { useContext, useEffect, useState } from "react"
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCart } from "../hooks/add_to_cart"
import { FaTimes } from "react-icons/fa";
import {LiaTimesSolid} from "react-icons/lia";
import { ProductDetails } from "../components/product_details"
import { useCookies } from "react-cookie"
import { useNavigate, useParams } from "react-router-dom"
import { BarLoader } from "react-spinners"
import { PayPalButtons } from "@paypal/react-paypal-js";
import { TostMessageContext } from "../context/TostMessage"

const ngn_states = [
        "Kano",
        "Lagos",
        "Kaduna",
        "Katsina",
        "Oyo",
        "Rivers",
        "Bauchi",
        "Jigawa",
        "Benue",
        "Anambra",
        "Borno",
        "Delta",
        "Imo",
        "Niger",
        "Akwa Ibom",
        "Ogun",
        "Sokoto",
        "Ondo",
        "Osun",
        "Kogi",
        "Zamfara",
        "Enugu",
        "Kebbi",
        "Edo",
        "Plateau",
        "Adamawa",
        "Cross River",
        "Abia",
        "Ekiti",
        "Kwara",
        "Gombe",
        "Yobe",
        "Taraba",
        "Ebonyi",
        "Nasarawa",
        "Bayelsa",
        "FCT"
    ];

export default function Checkout() {
    const [pageLoading, setPageLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [featured_prod, setFeaturedProd] = useState([]);
    const [products, setProducts] = useState([]);
    const { addToCart, checkItemInCart, removeItem, convertAmount, replaceCart } = useCart();
    const [showModal, setShowModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [cookies, setCookie] = useCookies();
    const navigate = useNavigate();
    const [payment, setPayment] = useState("cod");
    const [pageData, setPageData] = useState({});
    const {setTostMessage} = useContext(TostMessageContext);
    const {link_reference} = useParams();

    const [billing, setBilling] = useState({
        full_name: cookies?.billingInfo?.full_name ?? "",
        phone: cookies?.billingInfo?.phone ?? "",
        email: cookies?.billingInfo?.email ?? "",
        create_account: false
    });

    const [shipping, setShippingInfo] = useState(cookies?.shippingInfo ?? {});

    useEffect(() => {
        if (link_reference != undefined && link_reference != "") {
            getLinkData();
        }
    }, [])

    async function getLinkData() {
        const formData = new FormData();
        formData.append("link_reference", link_reference)
        try {
            const response = await axios.post(base_url + '/fetch-payment-link-items.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.data.status) {
                replaceCart(response.data.cart_items ?? [])
                setTostMessage({
                    messageType: 'success',
                    message: "Cart items loaded"
                })
            } else {

            }
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
        }
    }

    const calculateItemPrice = (item) => {
        const extrasTotal = Object.values(item.selected || {}).reduce(
        (sum, opt) => sum + Number(opt.amount_plus),
        0
        );

        return item.total_price;
    };

    const subtotal = cookies?.myCart?.reduce(
        (sum, item) => sum + calculateItemPrice(item),
        0
    );

    useEffect(() => {
        if (shipping?.country != "" && shipping?.country != null) {
            getShippingAmount(shipping?.country);
        }
    }, [shipping?.country])

    const getShippingAmount = async (country, d_state = "") => {
        const formData = new FormData();
        formData.append('country', country);
        formData.append('state', d_state)

        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_shipping_amount.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.data.status) {
                setPageData({ shipping_amount: response.data.shipping_amount })
            } else {

            }
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
        }
    }

    async function pay_ngn () {
        const formData = new FormData();
        formData.append('selections', JSON.stringify(cookies?.myCart));
        Object.entries(shipping).forEach(([key, value]) => {
            formData.append(key, value);
        });
        Object.entries(billing).forEach(([key, value]) => {
            formData.append(key, value);
        });

        setButtonLoading(true)
        try {
            const response = await axios.post(base_url + '/pay_ngn.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.data.status) {
                if (billing?.create_account) {
                    setCookie("billingInfo", billing, {
                        path: "/",
                        maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
                        secure: true,
                        sameSite: "strict"
                    });
                    setCookie("shippingInfo", shipping, {
                        path: "/",
                        maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
                        secure: true,
                        sameSite: "strict"
                    });
                }
                setTostMessage({
                    messageType: 'success',
                    message: response.data.message
                })
                window.open(response.data.payment_link, "_self");
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
            setButtonLoading(false)
        } catch (error) {
            setButtonLoading(false)
            setTostMessage({
                messageType: 'error',
                message: 'Network error'
            })
        }
    }

    return(
        <div className="w-full h-auto">
            {pageLoading && <LoadingOverlay />}
            <Navbar />
            <div className="max-w-6xl mx-auto px-4 py-6">
                <h1 className="text-2xl font-semibold mb-6">Chekout</h1>
                <div className="grid grid-cols-1 md:grid-cols-3">
                <div className="col-span-2 space-y-4 w-[-webkit-fill-available] px-5">
                    {[
                    ["Full Name*", "full_name"],
                    ["Email Address*", "email"],
                    ["Phone Number*", "phone"]
                    ].map(([label, key]) => (
                    <div key={key}>
                        <label className="text-sm text-gray-500">
                        {label}
                        </label>
                        <input
                        className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                        value={billing[key]}
                        onChange={(e) =>
                            setBilling({
                            ...billing,
                            [key]: e.target.value
                            })
                        }
                        />
                    </div>
                    ))}

                    <div className="flex flex-col mt-3">
                        <p className="text-2xl font-semibold">Shipping Information</p>
                        <div className="mb-3">
                            <label className="text-sm text-gray-500">
                            {'Street Address'}
                            </label>
                            <input
                            className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                            value={shipping?.street_address}
                            onChange={(e) => setShippingInfo({...shipping, street_address: e.target.value})}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="text-sm text-gray-500">
                            {'Select Country'}
                            </label>
                            <select
                            className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                            selected={shipping?.country}
                            value={shipping?.country}
                            onChange={(e) => {setShippingInfo({...shipping, country: e.target.value}); getShippingAmount(e.target.value)}}
                            >
                                <option value={''}>Select Country</option>
                                <option value={'NG'}>Nigeria (NG)</option>
                                <option value={'UK'}>United Kingdom (UK)</option>
                                <option value={'US'}>United States (USA)</option>
                            </select>
                        </div>
                        <div className="mb-3 grid grid-cols-1 md:grid-cols-3 gap-x-2">
                            {shipping?.country == "NG" ? 
                                <div className="col-span-1">
                                    <label className="text-sm text-gray-500">Destination State</label>
                                    <select
                                    className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                                    selected={shipping?.state}
                                    value={shipping?.state}
                                    onChange={(e) => {setShippingInfo({...shipping, state: e.target.value}); getShippingAmount(shipping?.country, e.target.value)}}
                                    >
                                        <option value={''}>Choose State</option>
                                        {ngn_states?.map((item, index) => 
                                            <option key={index} value={item}>{item}</option>
                                        )}
                                    </select>
                                </div>
                                : 
                                <div className="col-span-1">
                                    <label className="text-sm text-gray-500">
                                    {'State / County'}
                                    </label>
                                    <input
                                    className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                                    value={shipping?.state}
                                    onChange={(e) => setShippingInfo({...shipping, state: e.target.value})}
                                    />
                                </div>
                            }
                            <div className="col-span-1">
                                <label className="text-sm text-gray-500">
                                {'Town / City'}
                                </label>
                                <input
                                className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                                value={shipping?.town}
                                onChange={(e) => setShippingInfo({...shipping, town: e.target.value})}
                                />
                            </div>
                            <div className="col-span-1">
                                <label className="text-sm text-gray-500">
                                {'Postcode / ZIP'}
                                </label>
                                <input
                                className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                                value={shipping?.zip_code}
                                onChange={(e) => setShippingInfo({...shipping, zip: e.target.value})}
                                />
                            </div>
                        </div>
                    </div>

                    <label className="flex items-center gap-2 text-sm">
                    <input
                        type="checkbox"
                        checked={billing.create_account}
                        onChange={(e) =>
                        setBilling({
                            ...billing,
                            create_account: e.target.checked
                        })
                        }
                        className="accent-red-500"
                    />
                    Create my account (Become eligible for amazing offers)
                    </label>
                </div>

                {/* Order Summary */}
                <div className="col-span-1 border rounded-lg p-6 mt-3 md:mt-0">
                    {/* Items */}
                    <div className="space-y-4 mb-6">
                        {cookies?.myCart?.map((item, i) => (
                        <div key={i} className="flex justify-between">
                            <div className="flex gap-3">
                            <img
                                src={item.thumbnail}
                                className="w-10 h-10 object-contain"
                            />
                            <div>
                                <p className="font-medium">{item.name}</p>
                                <ul className="text-xs text-gray-500">
                                {Object.entries(item.selected || {}).map(
                                    ([k, v]) => (
                                    <li key={k}>
                                        {k}: {v.option}
                                    </li>
                                    )
                                )}
                                </ul>
                            </div>
                            </div>
                            <p className="font-medium">
                            {convertAmount(calculateItemPrice(item))}
                            </p>
                        </div>
                        ))}
                    </div>

                    <div className="border-t pt-4 space-y-2 text-sm">
                        <div className="flex justify-between">
                        <span>Subtotal</span>
                        <span>{convertAmount(subtotal)}</span>
                        </div>
                        <div className="flex justify-between">
                        <span>Shipping</span>
                        <span>{convertAmount(pageData?.shipping_amount ?? 0)}</span>
                        </div>
                        <div className="flex justify-between font-semibold text-lg">
                        <span>Total</span>
                        <span>{convertAmount(subtotal + (pageData?.shipping_amount ?? 0))}</span>
                        </div>
                    </div>

                    {/* Payment */}
                    {/* <div className="mt-6 space-y-3">
                        <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            checked={payment === "bank"}
                            onChange={() => setPayment("bank")}
                        />
                        Bank
                        </label>

                        <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            checked={payment === "cod"}
                            onChange={() => setPayment("cod")}
                        />
                        Cash on delivery
                        </label>
                    </div> */}

                    {/* Coupon */}
                    <div className="flex gap-3 mt-6">
                        <input
                        placeholder="Coupon Code"
                        className="border rounded px-4 py-2 flex-1 w-[50%] md:w-auto"
                        />
                        <button className="bg-[#fc8c06] text-white px-6 rounded">
                        Apply
                        </button>
                    </div>

                    <button onClick={() => pay_ngn()} className="mb-3 cursor-pointer w-full bg-[#7d5af6] text-white py-3 rounded mt-6">
                        {buttonLoading ? <BarLoader 
                            color={'#ffffff'}
                            loading={true}
                            size={7}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        /> : 'Pay NGN'}
                    </button>
                    <div className="text-center mx-auto w-full mb-3"><label>or</label></div>
                    <PayPalButtons
                        style={{ layout: "vertical", color: "gold", shape: "pill" }}
                        createOrder={(data, actions) => {
                        return fetch(base_url + "/initiate-paypal.php", {
                            method: "POST",
                            headers: {
                            },
                            body: JSON.stringify({
                                full_name: billing?.full_name,
                                email: billing?.email,
                                phone: billing?.phone,
                                create_account: billing?.create_account,
                                country: shipping?.country,
                                state: shipping?.state,
                                town: shipping?.town,
                                street_address: shipping?.street_address,
                                zip: shipping?.zip,
                                currency: 'GBP',
                                selections: cookies?.myCart
                            })
                        })
                        .then(res => res.json())
                        .then(order => order.orderID);
                        }}
                        onApprove={(data, actions) => {
                        return fetch(`${base_url}/capture-paypal.php?orderID=${data.orderID}`, {
                            method: "POST",
                            headers: {

                            },
                        })
                            .then(res => res.json())
                            .then(details => {
                            if (details.status) {
                                window.open(details.redirect_url, "_self");
                                if (billing?.create_account) {
                                    setCookie("billingInfo", billing, {
                                        path: "/",
                                        maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
                                        secure: true,
                                        sameSite: "strict"
                                    });
                                    setCookie("shippingInfo", shipping, {
                                        path: "/",
                                        maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
                                        secure: true,
                                        sameSite: "strict"
                                    });
                                }
                                setTostMessage({
                                    messageType: 'success',
                                    message: 'Payment completed!'
                                })
                            } else {
                                setTostMessage({
                                    messageType: 'error',
                                    message: 'Could not complete payment'
                                })
                            }
                            });
                        }}
                    />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}